const StorageWrapper = require('./storage-wrapper');

require('angular').module('oly.common')
    .factory('LocalStorageWrapper', () => new StorageWrapper(localStorage))
    .factory('SessionStorageWrapper', () => new StorageWrapper(sessionStorage));



// WEBPACK FOOTER //
// ./src/olycommon/localStorageWrapper/index.js